import styles from './SummaryTotal.module.scss';

interface Props {
  label: string;
  value: string | React.ReactNode;
  testId: string;
}

const SummaryTotal = ({ label, value, testId }: Props) => {
  return (
    <div className={styles.row} data-testid={testId}>
      <h3>{label}</h3>
      <div>{value}</div>
    </div>
  );
};

export default SummaryTotal;
